import { inter, philosopher } from "@/lib/fonts";
import { MessageCircleWarning } from "lucide-react";
import { useNavigate } from "react-router-dom";
import React from "react";

const ProductsComingSoon = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center gap-5 px-8">
      <div className="flex items-center justify-center w-35 h-35 rounded-full bg-[#DECEBE]/30">
        <div className="flex items-center justify-center w-28 h-28 rounded-full bg-primary shadow-md">
          <MessageCircleWarning className="text-white" size={70} />
        </div>
      </div>
      <h1
        className={`text-4xl font-semibold text-secondary ${philosopher.className}`}
      >
        Coming Soon...
      </h1>
      <h1
        className={`text-4xl font-semibold text-secondary ${philosopher.className}`}
      >
        Inshallah!
      </h1>
      <p className={`text-center text-[#6F6F6F] ${inter.className}`}>
        {`Products are on their way! We're working hard to bring you the best experience. Stay tuned for updates and be the first to explore our new offerings.`}
      </p>
      <button
        onClick={() => navigate(-1)}
        className={`w-full rounded-3xl bg-primary py-2 text-white shadow-md transition hover:opacity-90 ${inter.className}`}
      >
        Great !
      </button>
    </div>
  );
};

export default ProductsComingSoon;
